import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getShipmentComparisonAnalyticsNoShipments as getShipmentComparisonAnalyticsNoShipmentsApi,
    getShipmentComparisonAnalyticsTopZone as getShipmentComparisonAnalyticsTopZoneApi,
    getShipmentComparisonAnalyticsTopWeight as getShipmentComparisonAnalyticsTopWeightApi,
    getShipmentComparisonAnalyticsBaseChargeAmount as getShipmentComparisonAnalyticsBaseChargeAmountApi,
    getShipmentComparisonAnalyticsAvgBaseChargeAmount as getShipmentComparisonAnalyticsAvgBaseChargeAmountApi,
    getShipmentComparisonAnalyticsRecords as getShipmentComparisonAnalyticsRecordsApi,
    getShipmentComparisonBaseChargeAmount as getShipmentComparisonBaseChargeAmountApi,
    getShipmentComparisonAvgBaseChargeAmount as getShipmentComparisonAvgBaseChargeAmountApi,
    getCountByWeightAndZone as getCountByWeightAndZoneApi,
    getShipmentComparisonAnalyticsReport as getShipmentComparisonAnalyticsReportApi,
} from '../../helpers';
import { scenarioOptimizationsApiResponseSuccess, scenarioOptimizationsApiResponseError, } from './actions';
import { ScenarioOptimizationsActionTypes } from './constants';
import { analyticsRecordResponseToAnalyticsRecordObject } from '../../helpers/mappers/analyticsRecord';
import { totalCostByWeightAndZoneResponseToTotalCostByWeightAndZoneObject } from '../../helpers/mappers/totalCostByWeightAndZone';
import { totalCountByWeightAndZoneResponseToTotalCountByWeightAndZoneObject } from '../../helpers/mappers/totalCountByWeightAndZone';
import { addToast } from '../actions';
import { paginationHeadersResponse } from '../../helpers/mappers/pagination';

export function* getShipmentComparisonAnalyticsNoShipments({ payload: { query } }) {
    try {
        const response = yield call(getShipmentComparisonAnalyticsNoShipmentsApi, query);
        yield put(scenarioOptimizationsApiResponseSuccess(ScenarioOptimizationsActionTypes.GET_NO_SHIPMENTS_REQUEST, response.data));
    } catch (error) {
        yield put(scenarioOptimizationsApiResponseError(ScenarioOptimizationsActionTypes.GET_NO_SHIPMENTS_REQUEST, error));
    }
}

export function* getShipmentComparisonAnalyticsTopZoneSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentComparisonAnalyticsTopZoneApi, query);
        yield put(scenarioOptimizationsApiResponseSuccess(ScenarioOptimizationsActionTypes.GET_TOP_ZONE_REQUEST, response.data));
    } catch (error) {
        yield put(scenarioOptimizationsApiResponseError(ScenarioOptimizationsActionTypes.GET_TOP_ZONE_REQUEST, error));
    }
}

export function* getShipmentComparisonAnalyticsTopWeightSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentComparisonAnalyticsTopWeightApi, query);
        yield put(scenarioOptimizationsApiResponseSuccess(ScenarioOptimizationsActionTypes.GET_TOP_WEIGHT_REQUEST, response.data));
    } catch (error) {
        yield put(scenarioOptimizationsApiResponseError(ScenarioOptimizationsActionTypes.GET_TOP_WEIGHT_REQUEST, error));
    }
}

export function* getShipmentComparisonAnalyticsBaseChargeAmountSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentComparisonAnalyticsBaseChargeAmountApi, query);
        yield put(scenarioOptimizationsApiResponseSuccess(ScenarioOptimizationsActionTypes.GET_BASE_CHARGE_AMOUNT_REQUEST, response.data));
    } catch (error) {
        yield put(scenarioOptimizationsApiResponseError(ScenarioOptimizationsActionTypes.GET_BASE_CHARGE_AMOUNT_REQUEST, error));
    }
}

export function* getShipmentComparisonAnalyticsAvgBaseChargeAmountSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentComparisonAnalyticsAvgBaseChargeAmountApi, query);
        yield put(scenarioOptimizationsApiResponseSuccess(ScenarioOptimizationsActionTypes.GET_AVG_BASE_CHARGE_AMOUNT_REQUEST, response.data));
    } catch (error) {
        yield put(scenarioOptimizationsApiResponseError(ScenarioOptimizationsActionTypes.GET_AVG_BASE_CHARGE_AMOUNT_REQUEST, error));
    }
}

function* getShipmentComparisonAnalyticsRecords({ payload: { query } }) {
    try {
        const getAllAnalyticsRecordsResponse = yield call(getShipmentComparisonAnalyticsRecordsApi, query);
        const analyticsRecords = getAllAnalyticsRecordsResponse.data.map((analyticsRecordResponse) =>
            analyticsRecordResponseToAnalyticsRecordObject(analyticsRecordResponse)
        );
        const pagination = { ...paginationHeadersResponse(getAllAnalyticsRecordsResponse.headers), ...query };
        yield put(scenarioOptimizationsApiResponseSuccess(ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_RECORDS, { analyticsRecords, pagination }));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(scenarioOptimizationsApiResponseError(ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_RECORDS, error));
    }
}

function* getShipmentComparisonBaseChargeAmount({ payload: { query } }) {
    try {
        const getComparisonRatesBaseChargeAmountResponse = yield call(getShipmentComparisonBaseChargeAmountApi, query);
        yield put(scenarioOptimizationsApiResponseSuccess(ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_BASE_CHARGE_AMOUNT, getComparisonRatesBaseChargeAmountResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(scenarioOptimizationsApiResponseError(ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_BASE_CHARGE_AMOUNT, error));
    }
}

function* getShipmentComparisonAvgBaseChargeAmount({ payload: { query } }) {
    try {
        const getComparisonRatesAvgBaseChargeAmountResponse = yield call(getShipmentComparisonAvgBaseChargeAmountApi, query);
        yield put(scenarioOptimizationsApiResponseSuccess(ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_AVG_BASE_CHARGE_AMOUNT, getComparisonRatesAvgBaseChargeAmountResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(scenarioOptimizationsApiResponseError(ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_AVG_BASE_CHARGE_AMOUNT, error));
    }
}

function* getCountByWeightAndZone({ payload: { query } }) {
    try {
        const getCountByWeightAndZoneResponse = yield call(getCountByWeightAndZoneApi, query);
        const totalCountByWeightAndZone = getCountByWeightAndZoneResponse.data.map((totalCountByWeightAndZoneResponse) =>
            totalCountByWeightAndZoneResponseToTotalCountByWeightAndZoneObject(totalCountByWeightAndZoneResponse)
    );
        yield put(scenarioOptimizationsApiResponseSuccess(ScenarioOptimizationsActionTypes.GET_COUNT_BY_WEIGHT_AND_ZONE, totalCountByWeightAndZone));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(scenarioOptimizationsApiResponseError(ScenarioOptimizationsActionTypes.GET_COUNT_BY_WEIGHT_AND_ZONE, error));
    }
}

function* getShipmentComparisonAnalyticsReport({ payload: { query } }) {
    try {
        const getComparisonAnalyticsReportResponse = yield call(getShipmentComparisonAnalyticsReportApi, query);
        yield put(scenarioOptimizationsApiResponseSuccess(ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_REPORT, getComparisonAnalyticsReportResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(scenarioOptimizationsApiResponseError(ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_REPORT, error));
    }
}

export function* watchGetShipmentComparisonAnalyticsNoShipments(): any {
    yield takeLatest(ScenarioOptimizationsActionTypes.GET_NO_SHIPMENTS_REQUEST, getShipmentComparisonAnalyticsNoShipments);
}

export function* watchGetShipmentComparisonAnalyticsTopZone(): any {
    yield takeLatest(ScenarioOptimizationsActionTypes.GET_TOP_ZONE_REQUEST, getShipmentComparisonAnalyticsTopZoneSaga);
}

export function* watchGetShipmentComparisonAnalyticsTopWeight(): any {
    yield takeLatest(ScenarioOptimizationsActionTypes.GET_TOP_WEIGHT_REQUEST, getShipmentComparisonAnalyticsTopWeightSaga);
}

export function* watchGetShipmentComparisonAnalyticsBaseChargeAmount(): any {
    yield takeLatest(ScenarioOptimizationsActionTypes.GET_BASE_CHARGE_AMOUNT_REQUEST, getShipmentComparisonAnalyticsBaseChargeAmountSaga);
}

export function* watchGetShipmentComparisonAnalyticsAvgBaseChargeAmount(): any {
    yield takeLatest(ScenarioOptimizationsActionTypes.GET_AVG_BASE_CHARGE_AMOUNT_REQUEST, getShipmentComparisonAnalyticsAvgBaseChargeAmountSaga);
}

export function* watchGetShipmentComparisonAnalyticsRecords(): any {
    yield takeLatest(ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_RECORDS, getShipmentComparisonAnalyticsRecords);
}

export function* watchGetShipmentComparisonBaseChargeAmount(): any {
    yield takeLatest(ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_BASE_CHARGE_AMOUNT, getShipmentComparisonBaseChargeAmount);
}

export function* watchGetShipmentComparisonAvgBaseChargeAmount(): any {
    yield takeLatest(ScenarioOptimizationsActionTypes.GET_COMPARISON_RATES_AVG_BASE_CHARGE_AMOUNT, getShipmentComparisonAvgBaseChargeAmount);
}

export function* watchGetCountByWeightAndZone(): any {
    yield takeLatest(ScenarioOptimizationsActionTypes.GET_COUNT_BY_WEIGHT_AND_ZONE, getCountByWeightAndZone);
}

export function* watchGetShipmentComparisonAnalyticsReport(): any {
    yield takeLatest(ScenarioOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_REPORT, getShipmentComparisonAnalyticsReport);
}

function* scenarioOptimizationsSaga() {
    yield all([
        fork(watchGetShipmentComparisonAnalyticsNoShipments),
        fork(watchGetShipmentComparisonAnalyticsTopZone),
        fork(watchGetShipmentComparisonAnalyticsTopWeight),
        fork(watchGetShipmentComparisonBaseChargeAmount),
        fork(watchGetShipmentComparisonAvgBaseChargeAmount),
        fork(watchGetShipmentComparisonAnalyticsRecords),
        fork(watchGetShipmentComparisonAnalyticsBaseChargeAmount),
        fork(watchGetShipmentComparisonAnalyticsAvgBaseChargeAmount),
        fork(watchGetCountByWeightAndZone),
        fork(watchGetShipmentComparisonAnalyticsReport),
    ]);
}

export default scenarioOptimizationsSaga;
